import type { Invoice } from '~/types/models';

export function useInvoicePdfDownload() {
    const downloadingInvoiceIds = ref<string[]>([]);
    const isDownloadingInvoice = (invoiceId: string) => downloadingInvoiceIds.value.includes(invoiceId);

    async function downloadInvoicePdf(invoice: Invoice): Promise<void> {
        const tenantStore = useTenantStore();
        const { $auth } = useNuxtApp();
        const tenantId = String(tenantStore.currentTenantId || '').trim();
        const authUser = $auth.currentUser;
        if (!tenantId || !authUser) throw new Error('Sign in to download this invoice.');

        downloadingInvoiceIds.value = [...downloadingInvoiceIds.value, invoice.id];
        try {
            const blob = await $fetch<Blob>(`/api/invoices/${encodeURIComponent(invoice.id)}/pdf`, {
                query: { tenantId },
                headers: { authorization: `Bearer ${await authUser.getIdToken()}` },
                responseType: 'blob',
            });
            const objectUrl = URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = objectUrl;
            anchor.download = `${String(invoice.invoiceNumber || invoice.id).replace(/[^a-z0-9_.-]+/gi, '-')}.pdf`;
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
        } finally {
            downloadingInvoiceIds.value = downloadingInvoiceIds.value.filter(id => id !== invoice.id);
        }
    }

    return { downloadInvoicePdf, isDownloadingInvoice };
}
